import { render, staticRenderFns } from "./CardRewards.vue?vue&type=template&id=3794da2a&"
import script from "./CardRewards.vue?vue&type=script&lang=js&"
export * from "./CardRewards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports